import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { KmCatchUpAgreementService } from "../../../_services/matrix/products/km-catch-up-agreement.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { StatisticsService } from '../../../_services/statistics.service';
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from 'ngx-cookie';
import { Subscription } from "rxjs";
import { ToasterService, ToasterConfig } from "angular2-toaster/angular2-toaster";
import { Car } from "app/_models";
import { DealersService } from "app/_services/dealers.service";
import { MatrixCalculatorService } from "app/_services/matrix/matrix-calculator.service";
import { MatrixCarService } from "app/_services/matrix/matrix-cars.service";
import { Dealer } from "app/_models/dealer";
import { differenceInDays } from "date-fns";
import { KmCatchUpAgreement } from "app/_models/kmCatchUpAgreement";
import { MonitorKmService } from "app/_services/monitorkm.service";
import { vehicleKmRecord } from "app/_models/vehicleKmRecord";

@Component({
  selector: "app-km-catch-up-calculator",
  templateUrl: "./calculator.component.html",
  providers: [
    KmCatchUpAgreementService,
    CustomersService,
    DealersService,
    MatrixCalculatorService,
    MatrixCarService,
    ServiceOffersService,
    ServiceAddonsService,
    StatisticsService,
    CookieService,
    MonitorKmService,
  ],
})
export class KmCatchUpCalculatorComponent implements OnInit {
  public showMain: boolean = false;
  private customer: Customer;
  public hasResponded: boolean = false;
  public usedcar: Car;

  private regnr: string = "";
  private usedCarId: string = "";
  private customerid: string = "";
  private mauticId: string = "";
  private dealer: Dealer;
  private kmRecordId: string = "";
  private kmRecord: vehicleKmRecord;

  private errorMessage: string = "";
  private isLoading: boolean = true;

  public kmExceeded: number = 0;
  public monthsNeeded: number = 0;
  public calculatedPrice: number = 0;
  private payment_method: string = "";
  public startupPrice: number = 0;
  public kmPerYear: number = 15000;
  
  private mauticCustomer: any;
  private subscription: Subscription;
  private startDate: Date;
  private estimatedKms: number;

  public agreementStartDate: Date;
  public contactDealerAlert: boolean = false;

  // Add missing properties for template
  public extendOptions: any[] = [];
  public isActive: number = -1;

  // Add new properties for available options
  public options: any = {
    yearStep: [],
    kmStep: []
  };
  public yearSelected: string = "1";
  public kmSelected: number = 15000;
  public firstOptions: any;

  private cookieService: CookieService;
  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  constructor(
    toasterService: ToasterService,
    private activatedRoute: ActivatedRoute,
    private kmCatchUpAgreementService: KmCatchUpAgreementService,
    private customersService: CustomersService,
    cookieService: CookieService,
    private dealerService: DealersService,
    private matrixCalculatorService: MatrixCalculatorService,
    private matrixCarService: MatrixCarService,
    private modalService: NgbModal,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private statisticsService: StatisticsService,
    private monitorKmService: MonitorKmService
  ) {
    this.toasterService = toasterService;
    this.cookieService = cookieService;
  }

  ngOnInit() {
    this.isLoading = true;
    this.subscription = this.activatedRoute.params.subscribe(
      (params: any) => {
        this.customerid = params["id"];
        this.kmRecordId = params["record"] as string;
        console.log('Customer ID from route:', this.customerid);

        this.customersService.get(this.customerid).subscribe(
          (c) => {
            this.customer = c;
            this.usedCarId = c.usedCarId;
            if (c.regnr != null && c.regnr != "") {
              this.regnr = c.regnr.toString();
            }
            console.log(this.customer);
          },
          (e) => {
            this.errorMessage = e;
          },
          () => {
            this.matrixCarService.getCar(this.usedCarId).subscribe(
              (c) => {
                this.usedcar = c;
                console.log(this.usedcar);
              },
              (e) => (this.errorMessage = e)
            );

            this.dealerService.get(this.customer.dealer[0] as any).subscribe(
              (d) => {
                this.dealer = d;
                console.log(this.dealer);
                this.payment_method = d.payment_method;
              },
              (e) => (this.errorMessage = e),
              async () => {
                // Fetch vehicle km records for the customer
                try {
                  this.kmRecord = await this.monitorKmService.get(this.kmRecordId);
                  console.log('KM Record received:', this.kmRecord);
                  this.calculateExceededKilometers();
                  console.log(this.customer);
                } catch (error) {
                  console.error('Error fetching km record:', error);
                  this.errorMessage = error;
                  this.isLoading = false;
                }
              }
            );
          }
        );
      }
    );
  }

  calculateExceededKilometers() {
    // Use the already calculated exceeded kilometers from the km record
    this.kmExceeded = this.kmRecord.kmDifference || 0;
    console.log('Using exceeded kilometers from record:', this.kmExceeded);
    console.log('Actual KM:', this.kmRecord.actualKm);
    console.log('Expected KM:', this.kmRecord.expectedKm);
    console.log('KM Difference:', this.kmRecord.kmDifference);

    // Initialize with reasonable default values
    // Don't set kmSelected to kmExceeded directly as it might not be in available options
    this.kmSelected = 15000; // Default reasonable value
    this.yearSelected = "1";

    console.log('Initial selections:', {
      kmSelected: this.kmSelected,
      yearSelected: this.yearSelected,
      kmExceeded: this.kmExceeded
    });

    // Update available options - these will trigger price calculation
    this.updateAvailableYears();
    this.updateAvailableKms();
  }

  calculateCatchUpPrice() {
    // Calculate monthsNeeded for internal use and kmPerYear from selected values
    this.monthsNeeded = parseFloat(this.yearSelected) * 12;
    this.kmPerYear = this.kmSelected;

    console.log('Calculating price with:', {
      yearSelected: this.yearSelected,
      monthsNeeded: this.monthsNeeded,
      kmPerYear: this.kmPerYear,
      kmExceeded: this.kmExceeded
    });

    // Calculate price based on exceeded kilometers and catch-up period
    this.matrixCalculatorService
      .getUsedCarMonthlyPrice(
        this.usedCarId,
        this.yearSelected, // Pass years as string, not months
        Math.round(this.kmPerYear),
        new Date(this.customer.serviceAgreeEnd),
        new Date(this.customer.firstreg),
        this.kmRecord.actualKm
      )
      .subscribe(
        (p) => {
          this.calculatedPrice = p.monthlyPrice;
          console.log('Calculated price:', this.calculatedPrice);
          // Store the calculation details for checkout
          const catchUpDetails = {
            kmExceeded: this.kmExceeded,
            monthsNeeded: this.monthsNeeded,
            monthlyPrice: this.calculatedPrice,
            totalPrice: this.calculatedPrice * this.monthsNeeded
          };
          sessionStorage.setItem("kmCatchUpDetails", JSON.stringify(catchUpDetails));
          this.isLoading = false;
        },
        (e) => {
          console.error('Error calculating price:', e);
          this.errorMessage = e;
          this.isLoading = false;
        }
      );
  }

  updateAvailableYears() {
    this.options.yearStep = [];
    this.matrixCalculatorService
      .getAgreementLengths({
        carId: this.usedCarId,
        agreementStartDate: new Date(this.customer.serviceAgreeEnd),
        firstreg: new Date(this.customer.firstreg),
        maxKms: this.dealer.maxKms,
        maxLength: this.dealer.maxYears,
        selectedKms: this.kmSelected,
        carKms: (this.customer.actualkm as number) - (this.kmExceeded as number),
        showPartialYears: true,
        untilDate: new Date(this.customer.serviceAgreeEnd),
        currentAgreementKms: this.customer.serviceAgreeKm
      })
      .subscribe(
        (p) => {
          this.options.yearStep = p.ages;
          this.firstOptions = [...this.options.yearStep];
          if (p.ages.length) {
            this.yearSelected = p.ages.find(
              (length) => `${length}` === this.yearSelected
            )
              ? this.yearSelected
              : `${p.ages[p.ages.length - 1]}`;
          }
        },
        (e) => {
          this.errorMessage = e;
        },
        () => this.calculateCatchUpPrice()
      );
  }

  updateAvailableKms() {
    this.options.kmStep = [];
    this.matrixCalculatorService
      .getAgreementKms({
        carId: this.usedCarId,
        agreementStartDate: new Date(this.customer.lastservice),
        firstreg: new Date(this.customer.firstreg),
        maxKms: this.dealer.maxKms,
        carKms: (this.customer.actualkm as number) - (this.kmExceeded as number),
        showPartialYears: true,
        untilDate: new Date(this.customer.lastservice),
        currentAgreementKms: this.customer.serviceAgreeKm,
        maxLength: this.dealer.maxYears
      })
      .subscribe(
        (p) => {
          this.options.kmStep = p.kms;
          console.log('Available km options:', p.kms);
          if (p.kms.length) {
            this.kmSelected = p.kms.find(
              (kms) => Number(kms) === Number(this.kmSelected)
            )
              ? this.kmSelected
              : p.kms[0];
          }
          console.log('Selected km after update:', this.kmSelected);
          
          if (this.options.kmStep.length <= 1 && this.contactDealerAlert == false) {
            console.log('Setting price to 0 due to insufficient km options');
            this.calculatedPrice = 0;
            this.contactDealerAlert = true;
          }
        },
        (e) => {
          console.error('Error getting available kms:', e);
          this.errorMessage = e;
        },
        () => this.calculateCatchUpPrice()
      );
  }

  updateSelectedKms(event: number) {
    this.options.yearStep = [...this.firstOptions];
    this.kmSelected = event;
    this.updateAvailableYears();
  }

  updateSelectedYear(event: string) {
    this.options.yearStep = [...this.firstOptions];
    this.yearSelected = event;
    this.updateAvailableKms();
  }

  selectExtendOption(option: any, index: number) {
    this.isActive = index;
    // Update selections based on the extend option
    if (option && option.years) {
      this.yearSelected = option.years.toString();
    }
    if (option && option.km) {
      this.kmSelected = option.km;
    }
    // Trigger recalculation
    this.updateAvailableKms();
  }

  gotoCheckout(): void {
    let newItem: Partial<KmCatchUpAgreement> = {};
    newItem.car = [this.usedcar];
    newItem.customer = this.customerid;
    newItem.years = (this.monthsNeeded / 12).toString();
    newItem.km = ((this.customer.actualkm as number) + (this.kmSelected as number) as number).toString();
    newItem.price = this.calculatedPrice;
    newItem.actualkm = (this.customer.actualkm as number) - (this.kmExceeded as number);
    newItem.lastservice = this.customer.lastservice;
    newItem.previousServiceAgreementExpiration = this.customer.serviceAgreeEnd;
    newItem.previousServiceAgreementKilometers = this.customer.serviceAgreeKm;
    newItem.currentServiceAgreementExpiration = this.customer.serviceAgreeEnd;
    newItem.currentServiceAgreementKilometers = this.customer.serviceAgreeKm;
    
    sessionStorage.setItem("kmCatchUpAgree", JSON.stringify(newItem));

    top.window.location.href =
      "/#/km-catch-up/order-flow/checkout/" +
      this.customerid + '/' + this.kmRecordId;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
} 


// WEBPACK FOOTER //
// ./src/app/landingpages/kmCatchUp/order-flow/calculator.component.ts